


























































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import moment from "moment";
import { ScheduleDailyReport } from "@/api";

@Component
export default class DailyReportTab extends Vue {
  @Prop({ default: false }) isActive!: boolean;

  reportDate = moment().format("YYYY-MM-DD");
  dateMenu = false;
  departmentFilter: number | null = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  expanded: any[] = [];

  headers = [
    { text: "", value: "data-table-expand", sortable: false, width: "48px" },
    { text: "Title", value: "title", sortable: false },
    { text: "Total Employees", value: "totalEmployees", sortable: false },
    { text: "Total Hours", value: "totalHours", sortable: false },
  ];

  initials(name: string): string {
    return (name || "")
      .split(" ")
      .map((n: string) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  }

  get dailyReport(): ScheduleDailyReport | null {
    return this.$store.getters["schedule/dailyReport"];
  }

  get departments() {
    return this.$store.getters["company/departments"] || [];
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val) {
      this.fetchReport();
    }
  }

  @Watch("reportDate")
  onDateChange() {
    this.fetchReport();
  }

  @Watch("departmentFilter")
  onDepartmentChange() {
    this.fetchReport();
  }

  mounted() {
    if (this.isActive) {
      this.fetchReport();
    }
  }

  fetchReport() {
    this.$store.dispatch("schedule/fetchDailyReport", {
      date: this.reportDate,
      department: this.departmentFilter ?? undefined,
    });
  }
}
